import { z } from 'zod';
import { CursorQuery, Paginated } from '../../common/pagination.js';
import { AttachPaymentMethodInput, AttachPayoutInput, PaymentMethodView, PaymentView, PayoutView, } from '../../payment.js';
export const paymentRoutes = {
    methods: { method: 'GET', path: '/me/payment-methods', response: z.array(PaymentMethodView) },
    attachMethod: {
        method: 'POST',
        path: '/me/payment-methods',
        body: AttachPaymentMethodInput,
        response: PaymentMethodView,
    },
    removeMethod: {
        method: 'DELETE',
        path: '/me/payment-methods/:methodId',
        response: z.object({ id: z.string() }),
    },
    setDefault: {
        method: 'POST',
        path: '/me/payment-methods/:methodId/default',
        response: PaymentMethodView,
    },
    payouts: { method: 'GET', path: '/me/payouts', response: z.array(PayoutView) },
    attachPayout: {
        method: 'POST',
        path: '/me/payouts',
        body: AttachPayoutInput,
        response: PayoutView,
    },
    history: {
        method: 'GET',
        path: '/me/payments',
        query: CursorQuery,
        response: Paginated(PaymentView),
    },
};
//# sourceMappingURL=routes.js.map